/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
const colors = {
  turquoise: '#3ACABD',
  darkBlue: '#2F749C',
  ssBlue: '#00A1E0',
  ssGreen: '#4BC077',
  ssOrange: '#FF9828',
  ssNavey: '#496885',
  ssPurple: '#7F8DE1',
  ssRed: '#D64F48',

  kasmir: '#54698D',
  biscay: '#16325C',
  linkWater: '#F4F6F9',
  foam: '#F0F8FC',
  stream: '#E0E5EE',
  geyser: '#D8DDE6',
  cadetBlue: '#A8B7C7',
  avatar: '#D8DDE6',
  scienceBlue: '#0070D2',
  azure: '#1589EE',

  navy100: '#B1C2D2',
  navy200: '#7E97AF',
  navy500: '#284968',
  navy700: '#122F4C',

  blue100: '#75D9FF',
  blue200: '#37C0F5',
  blue500: '#0277A3',
  blue700: '#005A7C',

  green100: '#A5EABF',
  green200: '#72D697',
  green500: '#2EAD5D',
  green700: '#129643',

  orange100: '#FFBF7A',
  orange200: '#FFAB50',
  orange500: '#DE7503',
  orange700: '#AD5A00',

  purple100: '#CCD2FA',
  purple200: '#A9B3F0',
  purple500: '#5C6CCE',
  purple700: '#3D4EB5',

  red100: '#FFA8A3',
  red200: '#F77B74',
  red500: '#B92D26',
  red700: '#93140D',
};

export default colors;
